import React from 'react'

import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'
import {Loader} from '../../utils/misc'
export default class AddDiscount extends React.Component {

  constructor(props) {
    super(props)
    this.state = { discount: {is_percentage:true, rate:0, value:0, quantity:0}, loading:true}

    this.nameChange = this.nameChange.bind(this)
    this.rateChange = this.rateChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.submit = this.submit.bind(this)
    this.getDiscount = this.getDiscount.bind(this)
    this.deleteDiscount = this.deleteDiscount.bind(this)
  }

  deleteDiscount() {
    axios({
      url: '/delete_discount/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.discount
    }).then((response)=> {
      if(response.status === 200) {
          NotificationManager.success("Deleted Discount successfully")
        setTimeout(()=>{
          this.props.history.push("/discounts/")
        }, 700)
      }
    }).catch((err)=> {
      console.log(err);
    })
  }

  componentDidMount() {


    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.discount_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Discount " + this.props.match.params.discount_id
      this.getDiscount(this.props.match.params.discount_id).then((response)=>{
        if(response.status===200) {
          this.setState({discount: response.data.discount, loading:false})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }

    else {
        document.title = "Create Discount "
        this.setState({loading:false})
    }

  }

  getDiscount(discount_id) {
    return axios({
      url: '/get_discount/?serial='+discount_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  submit() {
    this.setState({submitting:true})


    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_discount/"
    }
    else {
      apiurl  = "/create_new_discount/"
    }


    axios({
      url: apiurl,
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.discount
    }).then((response)=> {
      if(response.status === 200) {

        this.setState({discount:response.data.discount, submitting:false})
        if(typeof this.props.onAddCallback !== "undefined") {
        this.props.onAddCallback(response.data.discount)
        }
        else {

          if(this.state.mode==="edit") {
            NotificationManager.success("Updated Discount successfully")
          }
          else {
            NotificationManager.success("Created Discount successfully")
          }

          setTimeout(()=>{

            this.props.history.push("/discounts/")
          }, 700)
        }

      }
    }).catch((err)=> {
      console.log(err);
    })

  }
  rateChange(e) {

    var value = e.target.value

    let discount = this.state.discount
    discount['rate'] = value
    discount['is_percentage'] = true
    discount['value'] = 0
    this.setState({discount:discount})
  }
  nameChange(e) {

    var value = e.target.value

    let discount = this.state.discount
    discount['value'] = value
    discount['is_percentage'] = false
    discount['rate'] = 0
    this.setState({discount:discount})
  }
  handleInputChange(e) {
    var name = e.target.name
    var value = e.target.value
    let discount = this.state.discount
    discount[name] = value
    this.setState({discount:discount})
  }



  render() {

    let submitButton = <button className="btn btn-success" onClick={this.submit}>Save</button>
    if(this.state.submitting) {
      submitButton = <button className="btn btn-success" disabled>Saving..</button>
    }


    if(this.state.loading) {
      return <Loader />
    }
    else {

        let discount = this.state.discount
        let pageHeader, deleteDiscountBtn
        if(this.state.mode === "edit") {
          pageHeader = <h3>{"Edit Discount  #" + discount.serial}</h3>
          deleteDiscountBtn = <button className="btn btn-danger" onClick={this.deleteDiscount}>Delete Discount</button>
        }
        else {
          pageHeader =  <h3 >Create New Discount</h3>
        }

      return <div>
        <section className="medium">
              {pageHeader}
              <ul className="list-inline">

                <li className="pull-right">{deleteDiscountBtn}</li>
              </ul>
        </section>
          <div className="form-horizontal">
              <div className="form-group">

                <div className="col-sm-6">
                  Minimum Units
                  <input type="text" value={discount.quantity} className="form-control input-sm" name="quantity" required onChange={this.handleInputChange}  />
                </div>

              </div>

              <div className="form-group">
                <div className="col-xs-5">
                  Percentage (%)
                  <input type="text" value={discount.rate} className="form-control input-sm" name="rate" onChange={this.rateChange} />
                </div>
                <div className="col-xs-2">
                  <br />
                  <h4 className="text-center">OR</h4>
                </div>
                <div className="col-xs-5">
                  Value (&#8377; )
                  <input type="text" name="value" value={discount.value} className="form-control input-sm" onChange={this.nameChange} />
                </div>
              </div>
              <div className="form-action-group">
              <p>Examples</p>
              <p>10 units 6% discount</p>
              <p>10 units Rs.300 discount</p>
              </div>
                <div className="form-action-group text-center">
                    {submitButton}
              </div>



      </div></div>
    }


  }
}



// WEBPACK FOOTER //
// ./src/components/discount/adddiscount.js